<template>
  <section
    v-if="albums.data.length"
  >
    <MainTitle
      title="Új fotósorozatok"
      subtitle="Galéria"
      sublink="/galeria"
    />
    <div class="flex flex-col lg:flex-row bg-gray-light">
      <card
        v-for="(item, index) in albums.data"
        :key="$unique() + index"
        class="mx-10 lg:mx-2.5 my-5 cursor-pointer"
        :url="'/galeria/album/' + item.id + '/' + item.slug"
        :title="item.title "
        :image="getMainImgObj(item)"
        image-class="h-[180px] md:h-[145px] 2xl:h-[180px] w-full object-cover"
      >
        <p
          v-if="item.photographers && item.photographers.length > 0"
          class="mb-4"
        >
          Fotó: 
          <span
            v-for="(photographer, index2) in item.photographers"
            :key="$unique() + index2"
          >{{
            photographer +
              (index2 !== item.photographers.length - 1 ? ", " : "")
          }}</span>
          <span class="block">
            {{ (item.text_taken_at ? item.text_taken_at : "") }}
          </span>
        </p>
      </card>
    </div>
  </section>
</template>
<script>
const MainTitle = () => import("~/components/folkradio/MainTitle.vue")
import card from '~/components/index/card.vue'
export default {
  components: {
    MainTitle,
    card
  },
  data () {
    return {
      albums: {
        data: []
      }
    }
  },
  fetch(){
    this.$axios
      .get("v2/albums?limit=3&filter[featured]=1").then(response => {
        this.albums = response.data;
      })
  },
  methods: {
    getMainImgObj(album) {
      if (album.photos && album.photos.length > 0) {
        for (let i = 0; i < album.photos.length; i++) {
          if (album.photos[i].primary === true) {
              return album.photos[i].photo;
          }
        }

        if (album.photos[0].photo.thumb) {
          return album.photos[0].photo;
        }
      }
      return null;
    },
    getMainImg(album) {
      if (album.photos && album.photos.length > 0) {
        for (let i = 0; i < album.photos.length; i++) {
          if (album.photos[i].primary === true) {
            if (album.photos[i].photo.thumb) {
              return album.photos[i].photo.thumb;
            } else {
              return album.photos[i].photo.url;
            }
          }
        }

        if (album.photos[0].photo.thumb) {
          return album.photos[0].photo.thumb;
        } else {
          return album.photos[0].photo.url;
        }
      }
      return "/img/event-default_w240.jpg";
    },
  }
}
</script>